import { EventActionType } from './event-action-type';

export interface SetEventPlaceNameAction {
  eventKey: string;
  name: string;
  type: EventActionType.SetEventPlaceName;
}

export const setEventPlaceName = (
  eventKey: string,
  name: string,
): SetEventPlaceNameAction => ({
  eventKey,
  name,
  type: EventActionType.SetEventPlaceName,
});
